// src/Pages/Privacy/Privacy.js
import React from "react";
import Footer from "../../components/Footer/footer";
import { t, getLangFromPathname } from "../../i18n";
import { useSiteContent } from "../../content/SiteContentContext";

const Privacy = () => {
  const siteContent = useSiteContent();
  // Päätellään kieli URL-polusta (/ = fi, /en/... = en, /es/... = es)
  const lang =
    typeof window !== "undefined"
      ? getLangFromPathname(window.location.pathname)
      : "fi";

  // Päivämäärä lokalisoituna (voit halutessa kovakoodata)
  const updatedDate = siteContent?.settings?.privacyUpdatedDate || "28.7.2025";

  return (
    <>
      <main className="mx-auto pt-24 pb-20 px-6 max-w-4xl">
        <section id="tietosuoja" className="scroll-mt-24">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-6 text-gray-900 dark:text-white">
            {t("privacyPage.title", lang)}
          </h1>

          <p className="text-sm text-gray-500 dark:text-gray-400 mb-10">
            {t("privacyPage.updatedAt", lang, { date: updatedDate })}
          </p>

          <p className="text-lg leading-relaxed mb-8 text-gray-800 dark:text-gray-200">
            {String(t("privacyPage.intro", lang))
              .replace(/<\/?domain>/g, "")
              .replace(/<\/?recaptcha>/g, "")}
          </p>

          {/* 1. Rekisterinpitäjä / Data Controller */}
          <h2 className="text-2xl font-bold mt-12 mb-4 text-gray-900 dark:text-white">
            {t("privacyPage.sections.controller.title", lang)}
          </h2>
          <p className="text-lg text-gray-800 dark:text-gray-200">
            {t("privacyPage.sections.controller.name", lang)}
            <br />
            {t("privacyPage.sections.controller.businessId", lang)}
          </p>

          {/* 2. Kerättävät tiedot / Data collected */}
          <h2 className="text-2xl font-bold mt-12 mb-4 text-gray-900 dark:text-white">
            {t("privacyPage.sections.collectedData.title", lang)}
          </h2>
          <ul className="list-disc list-inside space-y-2 text-lg text-gray-800 dark:text-gray-200">
            <li>{t("privacyPage.sections.collectedData.items.0", lang)}</li>
            <li>{t("privacyPage.sections.collectedData.items.1", lang)}</li>
            <li>{t("privacyPage.sections.collectedData.items.2", lang)}</li>
          </ul>

          {/* 3. Käyttötarkoitus / Purpose */}
          <h2 className="text-2xl font-bold mt-12 mb-4 text-gray-900 dark:text-white">
            {t("privacyPage.sections.purpose.title", lang)}
          </h2>
          <ul className="list-disc list-inside space-y-2 text-lg text-gray-800 dark:text-gray-200">
            <li>{t("privacyPage.sections.purpose.items.0", lang)}</li>
            <li>{t("privacyPage.sections.purpose.items.1", lang)}</li>
            <li>{t("privacyPage.sections.purpose.items.2", lang)}</li>
          </ul>

          {/* 4. Säilytys / Storage */}
          <h2 className="text-2xl font-bold mt-12 mb-4 text-gray-900 dark:text-white">
            {t("privacyPage.sections.storage.title", lang)}
          </h2>
          <p className="text-lg text-gray-800 dark:text-gray-200">
            {t("privacyPage.sections.storage.text", lang)}
          </p>

          {/* 5. Oikeudet / Rights */}
          <h2 className="text-2xl font-bold mt-12 mb-4 text-gray-900 dark:text-white">
            {t("privacyPage.sections.rights.title", lang)}
          </h2>
          <p className="text-lg text-gray-800 dark:text-gray-200">
            {t("privacyPage.sections.rights.text", lang)}
          </p>

          {/* 6. Yhteystiedot / Contact */}
          <h2 className="text-2xl font-bold mt-12 mb-4 text-gray-900 dark:text-white">
            {t("privacyPage.sections.contact.title", lang)}
          </h2>
          <p className="text-lg text-gray-800 dark:text-gray-200">
            {t("privacyPage.sections.contact.emailLabel", lang)}{" "}
            <a
              href={`mailto:${siteContent?.settings?.contactEmail || "kontakti@arttustenius.com"}`}
              className="text-lime-600 dark:text-lime-400 hover:underline"
            >
              {siteContent?.settings?.contactEmail || "kontakti@arttustenius.com"}
            </a>
            <br />
            {t("privacyPage.sections.contact.phoneLabel", lang)}{" "}
            <a
              href={`tel:${siteContent?.settings?.phoneHref || "+358443519265"}`}
              className="text-lime-600 dark:text-lime-400 hover:underline"
            >
              {siteContent?.settings?.phoneDisplay || "044 351 92 65"}
            </a>
          </p>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Privacy;

